export const supervisorNurseBaseAmount = [
    {
        base:101742
    }
]

export const supervisorNursePayIncrease = [
    {
        id: "0",
        expDiff: 0
    },
    {
        id: "1",
        expDiff: 1178
    },
    {
        id: "2",
        expDiff: 2352
    },
    {
        id: "3",
        expDiff: 2352
    },
    {
        id: "4",
        expDiff: 3517
    },
    {
        id: "5",
        expDiff: 4696
    },
    {
        id: "6",
        expDiff: 4696
    },
    {
        id: "7",
        expDiff: 5084
    },
    {
        id: "10",
        expDiff: 5874
    },
    {
        id: "13",
        expDiff: 6651
    },
    {
        id: "15",
        expDiff: 7044
    },
    {
        id: "17",
        expDiff: 8288
    },
    {
        id: "18",
        expDiff: 8904
    },
    {
        id: "20",
        expDiff: 9524
    },
]

export const supervisorNurseLongevity = [
    {
        id: "None",
        amount: 0
    },
    {
        id: "5 but less than 7",
        amount: 1283
    },
    {
        id: "7 but less than 10",
        amount: 5270
    },
    {
        id: "10 but less than 15",
        amount: 6690
    },
    {
        id: "15 but less than 20",
        amount: 14512
    },
    {
        id: "20 but less than 22",
        amount: 18616
    },
    {
        id: "22 years or more",
        amount: 24073
    }
]

export const supervisorNurseEducation = [
    {
        id: "Base Salary",
        amount: 0
    },
    {
        id: "Baccalaureate Differential",
        amount: 1952
    },
    {
        id: "Masters Differential",
        amount: 3909
    }
]